import { Rule } from './rule';

export class TwentyOneCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.21-or-bust.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.21-or-bust.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.21-or-bust.header-2',
      body: [
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-2a' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-2b' },
      ],
    },
    {
      title: 'components.cheat-sheet.21-or-bust.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-3b' },
      ],
    },
    {
      title: 'components.cheat-sheet.21-or-bust.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-4b' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-4c' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-4d' },
      ],
    },
    {
      title: 'components.cheat-sheet.21-or-bust.header-5',
      body: [
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-5a' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-5b' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-5c' },
      ],
    },
    {
      title: 'components.cheat-sheet.21-or-bust.header-6',
      body: [
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-6a' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-6b' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-6c' },
        { type: 'text', content: 'components.cheat-sheet.21-or-bust.body-6d' },
      ],
    },
  ];
}
